export default __webpack_public_path__ + "static/media/MonthForecast.6d4b50d4.svg";